// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Avatar {
  display: flex;
  width: 100%;
  justify-content: center;
}
.Avatar__ImageWrapper {
  flex: 1;
  width: 50%;
  max-width: 10rem;
  height: 10rem;
  border-radius: 50%;
}
.Avatar__Image {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./libs/features/shared/components/src/lib/avatar/avatar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,uBAAA;AACF;AACE;EACE,OAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AACJ;AAEE;EACE,WAAA;EACA,YAAA;AAAJ","sourcesContent":[".Avatar {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n\n  &__ImageWrapper {\n    flex: 1;\n    width: 50%;\n    max-width: 10rem;\n    height: 10rem;\n    border-radius: 50%;\n  }\n\n  &__Image {\n    width: 100%;\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
